export const AgentsQueryKeys = {
    all: ['fields'] as const,
    lists: () => [...AgentsQueryKeys.all, 'list'] as const,
    list: (filters: object) => [...AgentsQueryKeys.lists(), filters] as const,
    details: () => [...AgentsQueryKeys.all, 'detail'] as const,
    detail: (id: string) => [...AgentsQueryKeys.details(), id] as const,
  };
  